import { useTheme } from '@mui/material';
import Typography from '@mui/material/Typography';

import { MessagingChannel } from '~hooks/useMessaging/models';
import { listsMessagingChannelMembers } from '~pages/Messages/messagingChannelLabels';
import { Nullable } from '~types/Nullable';

import MessagingChannelMembersButton from './MessagingChannelMembersButton';

type MessagingChannelSubtitleProps = {
  channel: Nullable<MessagingChannel>;
  label: string;
};

export default function MessagingChannelSubtitle({
  channel,
  label,
}: MessagingChannelSubtitleProps) {
  const theme = useTheme();

  if (channel && listsMessagingChannelMembers(channel)) {
    // Keyed so an open member list closes instead of showing the next conversation's members.
    return (
      <MessagingChannelMembersButton channel={channel} key={channel.id} label={label} />
    );
  }

  return (
    <Typography noWrap sx={{ color: theme.semantic.textSecondary }} variant="caption">
      {label}
    </Typography>
  );
}
